import React from 'react'

import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next';

import './footer.css'

const Footer = (props) => {

  const { t } = useTranslation();
  
  return (
    <footer className="footer-footer">
      <div className="footer-information">
        <div className="footer-content">
          <img
            alt={props.imageAlt3}
            src={props.imageSrc3}
            className="footer-image"
          />
        </div>
        <span className="footer-copyright">{t('footer.copyright')}</span>
      </div>
      <div className="footer-links">
        <div className="footer-column1">
          <span className="link"><a href="#">{t('footer.links.home')}</a></span>
          <span className="link"><a href="#services">{t('footer.links.services')}</a></span>
          <span className="link"><a href="#skills">{t('footer.links.skills')}</a></span>
          <span className="link"><a href="#team">{t('footer.links.team')}</a></span>
          <span className="link"><a href="#contacts">{t('footer.links.contacts')}</a></span>
        </div>
        <div className="footer-column2">
          <span className="link"><a href="https://www.linkedin.com/company/do-smart-it-consulting" target="_blank" rel="noopener noreferrer">Linkedin</a></span>
          <span className="link"><a href="https://livroreclamacoes.pt/" target="_blank" rel="noopener noreferrer"></a></span>    
          <a href="https://livroreclamacoes.pt/" target="_blank" rel="noopener noreferrer"><img
            alt={props.text7}
            src={props.imageSrcComplaints}
          ></img></a>
        </div>
      </div>
    </footer>
  )
}

Footer.defaultProps = {
  imageAlt3: 'image',
  imageSrc3:
    '/images/logo_regular_right_transparent_cropped.png',
  text7: 'Livro de Reclamações',
  imageSrcComplaints: '/images/logo_livro_reclamacoes.png',
}

Footer.propTypes = {
  imageAlt3: PropTypes.string,
  imageSrc3: PropTypes.string,
  text7: PropTypes.string,
}

export default Footer
